import React, { useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'



const ChartWrapper = styled.div`
  height: 100%;
`

const Chart = () => {
  const chartRef = useRef<HTMLDivElement>()
  return (
    <div className="video-responsive">
      <iframe  title="gr"  width="100%" border-radius="15px"  height="150%" frameBorder="0" scrolling="no" src="https://coinbrain.com/embed/bnb-0xadaae082237cb1772c9e079db95c117e6dd0c5af?theme=custom&accent=3ad5a3&padding=16&background=000000&chart=1&trades=0&simple=0"/>
      </div>  
  )
}

export default Chart
